import React from 'react';
import TitleMC from './TitleMC';

const TitleDescriptionMC = ({ title, description, className }) => (
  <TitleMC
    text={title}
    suffix={description}
    className={`!tw-block !tw-max-h-none ${className}`}
    suffixClassName="tw-text-xs tw-text-gray-950 tw-font-normal"
    variant="MODAL_TITLE"
  />
);

export default TitleDescriptionMC;
